module.exports = __webpack_public_path__ + "static/media/qr.44a12608.svg";